import { writeLocalStorage } from "../browserUtils";
import { canPaste, clipboardKey } from "./commons";
function replacer(key, value) {
    return key !== undefined && value === undefined ? null : value;
}
function clipboardCopy(content, keepUndefined) {
    const dataToWrite = keepUndefined
        ? JSON.stringify(content, replacer)
        : JSON.stringify(content);
    if (canPaste()) {
        navigator.clipboard.writeText(dataToWrite);
    }
    else {
        writeLocalStorage({ key: clipboardKey, data: dataToWrite });
    }
}
export default clipboardCopy;
//# sourceMappingURL=clipboardCopy.js.map